<template>
  <div class="content">
    <ads :adsList="adsList"></ads>
    <div :class="['header', adsList && adsList.length > 0 ? '' : 'default-bg']">
      <div class="top">
        <div class="top-left">
          <img class="logo" :src="`${staticUrl}img-logo.png` | handleImageUrl('60', '30')" />
          <a class="change-title" href="category.html">
            <p>{{ categoryTitle }}</p>
          </a>
        </div>
        <div class="top-left">
          <p class="iconfont icon-kefu" @click="goPage('kefu')"></p>
          <p class="iconfont icon-sangedian" @click="onIconClick"></p>
        </div>
      </div>
      <div class="search">
        <input type="text" placeholder="输入您要搜索的内容" v-model="searchTitle" />
        <a @click="goPage('search')">
          <p class="iconfont icon-query"></p>
        </a>
      </div>
      <div class="text" v-if="adsList == null">
        <p>来学宝典</p>
        <a :href="`http://app.laixue.com`">
          <button class="download-now">立即下载</button>
        </a>
       <img :src="`${staticUrl}img-pc.png` | handleImageUrl('316', '236')" class="pc" />
      </div>
    </div>
    <ul class="tip" :class="[adsList && adsList.length > 0 ? '' : 'default-margin']">
      <li @click="goPage('courses')">
        <img :src="`${staticUrl}img-icon-video.jpg` | handleImageUrl('88', '88')" />
        <h4>热门课程</h4>
      </li>
      <li @click="goPage('tikus')">
        <img :src="`${staticUrl}img-icon-tiku.jpg` | handleImageUrl('88', '88')" />
        <h4>在线题库</h4>
      </li>
      <li @click="goPage('headline')">
        <img :src="`${staticUrl}img-icon-news.jpg` | handleImageUrl('88', '88')" />
        <h4>考试资讯</h4>
      </li>
      <li @click="goPage(`http://www.${domain}/weixin/query`)">
        <img :src="`${staticUrl}icon-check.jpg` | handleImageUrl('88', '88')" />
        <h4>验证微信</h4>
      </li>
      <li @click="goPage(`teacher`)">
        <img class="teacher-img" src="../../images/teacher.png" alt="">
        <h4>名师风采</h4>
      </li>
      <li @click="goPage(`wszg`)">
        <img class="wszg-img" src="../../images/wszg.png" alt="">
        <h4>卫生资格</h4>
      </li>
    </ul>
    <div class="title">
      <p class="title-left">来学头条</p>
      <div class="title-right" @click="goPage('headline')">
        <p>更多头条</p>
        <p class="iconfont icon-gengduo"></p>
      </div>
    </div>
    <recommend :isShowHead="isShowHead" :mostNews="mostNews" :lastestNews="lastestNews" :categoryTitle="categoryTitle"></recommend>
    <div class="place" v-if="courses"></div>
    <div class="title mgt20" v-if="courses">
      <p class="title-left"><span class="red">热门</span>课程</p>
      <div class="title-right" @click="goPage('courses')">
        <p>更多课程</p>
        <p class="iconfont icon-gengduo"></p>
      </div>
    </div>
    <course :courses="courses"></course>
    <div class="place"></div>
    <div class="title mgt20">
      <p class="title-left">最新<span class="blue">资讯</span></p>
      <div class="title-right" @click="goPage('news')">
        <p>更多资讯</p>
        <p class="iconfont icon-gengduo"></p>
      </div>
    </div>
    <information :isShowHead="isShowHead" :articleList="articleList" :categoryTitle="categoryTitle"></information>
    <div class="place"></div>
    <div class="title mgt20">
      <p class="title-left">在线<span class="blue">题库</span></p>
      <div class="title-right" @click="goPage('tikus')">
        <p>更多题库</p>
        <p class="iconfont icon-gengduo"></p>
      </div>
    </div>
    <tiku :tikus="tikus"></tiku>
    <div class="place"></div>
    <div class="icon-popup" v-if="hasPopup">
      <a :href="`/quality-car.html?isShowHead=${isShowHead}`" class="icon-text icon-text-boredr" @click="onIconClick">
        质检直通车
      </a>
      <a :href="`http://www.${domain}/weixin/query`" class="icon-text icon-text-boredr" @click="onIconClick">
        微信查询
      </a>
      <a href="/about.html" class="icon-text" @click="onIconClick">关于我们</a>
    </div>
    <foot></foot>
    <div class="warning" v-if="isShowPolicy" @touchmove.prevent>
      <div class="model">
        <div class="privacy-policy">用户隐私政策</div>
        <div class="model-content">
          <div class="model-title">
            欢迎访问来学网，在正式试用之前请您认真阅读我们的
            <a :href="privacyPolicy" style="color: #3385ff">《隐私政策》</a>
            您在使用来学网时，我们会收集和使用您的相关信息。
          </div>
          <div class="model-title">
            我们希望通过本<a :href="privacyPolicy" style="color: #3385ff">《隐私政策》</a>
            向您说明，在使用来学网时，我们如何收集、使用、储存、分享和保护这些信息，
            以及我们为您提供的了解、更新、控制和保护这些信息的方式。
          </div>
          <div>
            您使用或继续使用来学网，视为您同意我们按照本
            <a :href="privacyPolicy" style="color: #3385ff">《隐私政策》</a>
            收集、使用、储存、分享和保护您的信息。请您仔细阅读并按照本
            <a :href="privacyPolicy" style="color: #3385ff">《隐私政策》</a>的指引，作出您认为适当的选择。
          </div>
        </div>
        <div style="border-top: 1px solid rgb(229, 229, 229)"></div>
        <div style="text-align: center">
          <div class="agreement" style="background-color: #e9e9ed; color: #333" @click="unAgree">不同意</div>
          <div class="agreement" @click="onAgree">同意并继续</div>
        </div>
      </div>
    </div>
    <div class="warning" v-if="isUnAgree">
      <div class="model">
        <div style="line-height: 80px; text-align: center">如不同意，请关闭本页面，退出本站浏览</div>
        <div class="agreement" style="display: block; margin: 20px auto" @click="isUnAgree = false">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
import ads from '../../components/data/ads.vue';
import course from '../../components/data/course';
import information from '@/components/data/information.vue';
import recommend from '@/components/data/recommend.vue';
import tiku from '../../components/data/tikus';
import foot from '../../components/layouts/footer';

let categoryId = null;
export default {
  components: { recommend, information, course, tiku, foot, ads },
  data() {
    return {
      adsList: [],
      articleList: null,
      domain: process.env.VUE_APP_DOMAIN,
      mostNews: [],
      lastestNews: [],
      courses: [],
      tikus: [],
      staticUrl: process.env.VUE_APP_CDN,
      categoryTitle: '分类',
      searchTitle: '',
      hasPopup: false,
      isShowHead: true,
      isShowPolicy: true, // 是否显示隐私政策弹框
      isUnAgree: false, // 是否点击了不同意
      privacyPolicy: 'http://laixue.com/policy?type=PRIVATE',
      examDate: '',
    };
  },

  mounted() {    
    categoryId = this.$context.query.category_id;
    this.categoryTitle = this.$context.query.title;

    if (!categoryId) {
      window.location.href = `/category.html`;
      return;
    }

    if (this.isWechat()) {
      this.isShowHead = false;
    }

    let agreement = localStorage.getItem('agreement');
    if (agreement) {
      this.isShowPolicy = false;
    }

    this.getAds();
    this.getArticles();
    this.getNews('h|c', 20);
    this.getCourses();
    this.getTikus();
    this.getExamDate();
  },

  methods: {
    async getExamDate() {
      this.examDate = await this.examDateFun(categoryId);
    },

    // 获取h5顶部广告
    getAds() {
      this.$http.get({ name: 'ad.index', data: { position: 'POS_H5_PAGE_TOP' } }).then((res) => {
        if (res.data.error_code) return;
        this.adsList = res.data.items;
      });
    },

    getArticles() {
      this.$http
        .get({
          name: 'article',
          data: {
            category_id: categoryId,
            per_page: 6,
          },
        })
        .then((res) => {
          if (res.data.error_code) {
            return;
          }
          this.articleList = res.data.items;
        });
    },

    getCourses() {
      this.$http
        .get({
          name: 'courses',
          data: {
            category_id: categoryId,
            onsale: 1,
            is_latest: 1,
            per_page: 3,
            type: 0,
          },
        })
        .then((res) => {
          if (res.data.error_code && res.data.error_code !== 'SUCCESS') {
            return;
          }
          const items = res.data.items || [];
          this.courses = items.filter((item) => item.status != 'NEW');
          if (res.data.total_count === 0 || items.length === 0) {
            this.getCategorys();
          }
        })
    },

    getCategorys() {
      let config = {
        name: 'category.index',
        data: {
          refid: categoryId,
          flag: 'y',
        },
      };

      this.$http.get(config).then((res) => {
        if (res.data.error_code && res.data.error_code !== 'SUCCESS') {
          return;
        }
        this.fetchCoursesByCategory(res.data.items[0].id);
      });
    },

    fetchCoursesByCategory(levelFourId) {
      let config = {
        name: 'courses',
        data: {
          category_id: levelFourId,
          is_latest: 1,
          page: 1,
          per_page: 3,
          onsale: 1,
          type: 0, // 点播
          sort: 'rank',
        },
      };

      this.$http.get(config).then((res) => {
        if (res.data.error_code && res.data.error_code !== 'SUCCESS') {
          return;
        }
        this.courses = res.data.items;
      });
    },

    getNews(flag, perpage) {
      this.$http
        .get({
          name: 'article',
          data: {
            category_id: categoryId,
            per_page: perpage,
            flag: flag,
          },
        })
        .then((res) => {
          this.fillNews(res, flag);
        });
    },

    fillNews(res, flag) {
      if (res.data.error_code && res.data.error_code != 'SUCCESS') {
        return;
      }

      let items = res.data.items || [];
      if (flag === 'h|c') {
        this.mostNews = items; // fixed h5-移动端来学网首页：首页来学头条和头条详情页不显示数据
        this.getNews('h', this.mostNews.length + 3);
      }

      // fix issue #2184 获取除了点击最多以外的其他头条资讯
      if (flag === 'h') {
        this.mostNews.forEach((mNews) => {
          items = items.filter((item) => item.id != mNews.id);
        });
        this.lastestNews = items.slice(0, 3);
      }
    },

    getTikus() {
      this.$http
        .get({
          name: 'exam.index',
          data: {
            category_id: categoryId,
            per_page: 4,
          },
        })
        .then((res) => {
          if (res.data.error_code && res.data.error_code !== 'SUCCESS') {
            return;
          }
          this.tikus = res.data.items;
        });
    },

    goPage(pageUrl) {
      let href = pageUrl;
      if (href.includes('http')) {
        window.location.href = href;
        return;
      }

      let isAt = false;
      switch (pageUrl) {
        case 'news':
          isAt = true;
          href = `/news/index.html?category_id=${categoryId}&title=${this.categoryTitle}&examDate=${this.examDate}`;
          break;
        case 'search':
          isAt = true;
          href = `/search.html?category_id=${categoryId}&searchTitle=${this.searchTitle}`;
          break;
        default:
          href = `/${pageUrl}.html?category_id=${categoryId}&title=${this.categoryTitle}&examDate=${this.examDate}`;
          break;
      }

      if (!this.isShowHead) {
        window.location.href = href;
        return;
      }

      if (isAt) {
        window.location.href = `${href}&isShowHead=${this.isShowHead}`;
        return;
      }

      window.location.href = `${href}&isShowHead=${this.isShowHead}`;
    },

    onIconClick() {
      this.hasPopup = !this.hasPopup;
    },

    unAgree() {
      this.isUnAgree = true;
      setTimeout(() => {
        this.isUnAgree = false;
      }, 5000);
    },

    onAgree() {
      this.isShowPolicy = false;
      localStorage.setItem('agreement', true);
    },
  },
};
</script>
<style scoped>
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.header {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 999;
}

.default-bg {
  height: 540px;
  background: #3c8fe4;
}

.top {
  display: flex;
  justify-content: space-between;
  padding: 50px 20px 0 21px;
  color: #fff;
  font-size: 32px;
}

.icon-popup {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 100px;
  right: 0px;
  width: 100%;
  background: #fff;
  z-index: 999;
}

.icon-text {
  display: block;
  width: 100%;
  height: 80px;
  line-height: 80px;
  font-size: 32px;
  color: #000;
  text-align: center;
}
.icon-text-boredr {
  border-bottom: 1px solid #efefef;
}
.top-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.icon-kefu {
  margin-right: 20px;
}

.top-left .change-title {
  display: flex;
  justify-content: flex-start;
}

.top-left .change-title::after {
  content: '';
  display: block;
  margin: 21px 0 0 9px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 18px 18px 0 0;
  border-color: transparent #fff transparent transparent;
}

.logo {
  margin-right: 29px;
  width: 60px;
  height: 30px;
}

.text {
  padding-left: 70px;
}

.text p {
  padding-left: 10px;
  color: #fff;
  font-size: 48px;
  font-family: 'zihun35hao-jindianyahei';
  font-weight: bold;
  letter-spacing: 4px;
}

.download-now {
  margin-top: 54px;
  width: 231px;
  height: 69px;
  border-radius: 34px;
  border: none;
  background: #e2d320;
  color: #333;
  font-size: 30px;
  font-weight: bold;
}

.pc {
  position: absolute;
  bottom: 24px;
  right: 72px;
  width: 316px;
  height: 236px;
}

.search {
  display: flex;
  justify-content: space-between;
  margin: 50px auto 54px;
  width: 630px;
  height: 60px;
  padding: 0 48px;
  line-height: 60px;
  background: #77b1ec;
  border-radius: 30px;
  color: #bbd8f6;
  box-sizing: border-box;
}

input {
  text-indent: 4px;
  border: none;
  outline: none;
  background: none;
  font-size: 26px;
  color: #fff;
}

input::placeholder {
  font-size: 26px;
  color: #fff;
}

.teacher-img {
  width: 88px;
  height: 88px;
}

.title {
  display: flex;
  justify-content: space-between;
  padding: 46px 27px;
  height: 36px;
  line-height: 36px;
  color: #333;
  font-size: 36px;
  font-weight: bold;
}

.title-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #999;
  font-size: 26px;
}

.icon-gengduo {
  margin-top: 2px;
  font-size: 10px;
}

.red {
  color: #da1919;
}

.blue {
  color: #1296db;
}

h4 {
  margin-top: 20px;
  color: #333;
  text-align: center;
  font-size: 28px;
  letter-spacing: 2px;
}

.default-margin {
  margin-top: 520px !important;
}

.tip {
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
  align-items: center;
}

.tip img {
  display: block;
  margin: 0 auto;
  width: 88px;
  height: 88px;
}

.tip li {
  margin-top: 40px;
  width: 187px;
}

a {
  color: #fff;
  text-decoration: none;
}

.place {
  height: 20px;
  background: #eee;
}

.mgt20 {
  margin-top: 20px;
}
.model {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  background: #fff;
  border-radius: 20px;
}

.privacy-policy {
  padding: 20px;
  text-align: center;
  color: #000;
  border-bottom: 1px solid rgb(229, 229, 229);
}

.model-content {
  padding: 20px;
  font-size: 30px;
  color: #000;
}

.model-title {
  margin-bottom: 20px;
}

.agreement {
  display: inline-block;
  margin: 20px 10px;
  padding: 8px;
  width: 180px;
  background: #3385ff;
  border: none;
  color: #fff;
  text-align: center;
  border-radius: 14px;
}

.warning {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(40, 40, 40, 0.4);
  z-index: 999;
}
</style>
